<template>
  <v-container fill-height fluid>
    <v-layout justify-center wrap>
      <v-flex xs12 md10>
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="130">
            <v-icon size="50" color="success">mdi-calendar-multiple-check</v-icon>
          </v-avatar>
          <v-card-text class="text-xs-center">
            <h6 v-if="!vacation.collectiveVacation" class="category text-gray font-weight-thin mb-3">{{vacation.vacationType ? vacation.vacationType.name : $t('Common.not_assigned')}}</h6>
            <h6 v-else class="category text-gray font-weight-thin mb-3">{{$t('Pages.CollectiveVacations.title_singular')}}</h6>
            <h5 class="card-title font-weight-medium">{{vacation.user ? vacation.user.profile.name : ''}}</h5>
            <h4 class="card-title font-weight-medium">{{getLocaleDateFormat(vacation.start)}} - {{getLocaleDateFormat(vacation.end)}}</h4>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout row wrap>
                  <!--<v-flex xs12 md4>
                    <v-layout column class="text-xs-center">
                      <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Vacations.model.duration_previous')}}</label>
                      <p>{{-1*vacation.duration_previous}}</p>
                    </v-layout>
                  </v-flex>-->
                  <v-flex xs12 md6>
                    <v-layout column class="text-xs-center">
                      <label class="text-primary font-weight-thin mb-1">{{$t('Common.created_at')}}</label>
                      <p>{{vacation.created_at}}</p>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-layout column class="text-xs-center">
                      <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Vacations.model.duration')}}</label>
                      <p class="card-description font-weight-light">{{vacation.isVacationDays ? vacation.duration : -1*vacation.duration}}</p>
                    </v-layout>
                  </v-flex>
                  <!--<v-flex xs12 md4>
                    <v-layout column class="text-xs-center">
                      <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Vacations.model.duration_next')}}</label>
                      <p class="card-description font-weight-light">{{-1*vacation.duration_next}}</p>
                    </v-layout>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 md12>
                    <v-layout column class="text-xs-center">
                      <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Vacations.model.status')}}</label>
                      <p>{{getLocaleVacationStatus(vacation.status)}}</p>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row wrap class="mt-3" v-for="(response, index) in vacation.vacationResponses" :key="index">
                  <v-flex xs12 md12>
                    <v-layout column class="text-xs-center">
                      <p class="text-capitalize font-weight-bold title" :class="getLocaleVacationStatus(response.status) == $t('VacationRequestStatuses.declined') ? 'text-danger' : 'text-info'">{{getLocaleVacationStatus(response.status) + ' ' + $t('Common.by') + ' ' + response.user ? response.user.profile.name : ''}}</p>
                      <p class="font-weight-light font-italic mt-2 body-1">{{response.description}}</p>
                      <p class="font-italic font-weight-thin text-xs-right caption">{{response.created_at}}</p>
                      <v-divider></v-divider>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-btn v-if="hasRole(UserRoles.ADMIN)" color="warning" round class="font-weight-light" :to="'/vacation-requests/' + vacation.id + '/update'">{{$t('Core.Fields.edit')}}</v-btn>
            <v-btn dark @click="dialog = true" :disabled="!vacation.canRespond" v-if="hasAnyRole([UserRoles.REVISER, UserRoles.DIRECTOR])" color="indigo" round class="font-weight-light">
                {{$t('Core.Fields.respond')}}
            </v-btn>
            <v-btn round class="font-weight-light" href="javascript:history.go(-1)">{{$t('Core.Fields.back')}}</v-btn>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>

    <respond-dialog @close="onCloseDialog" :dialog="dialog" :id="vacation.id"></respond-dialog>
  </v-container>
</template>

<script>
    import _ from 'lodash';
    import RespondDialog from './RespondDialog'
    export default {
        components: {RespondDialog},
        data: () => ({
            vacation: {},
            dialog: false,
        }),
        computed: {

        },
        created () {
            this.getVacation();
        },
        methods: {
            onCloseDialog(refresh){
                this.dialog = false;

                refresh && this.getVacation();

            },
            getVacation(fetching = true){
                this.setFetching(fetching);
                this.repositories.vacationRequest.get(this.$route.params.id, 'user,vacationType,collectiveVacation').then(response => {
                    this.vacation = response.data.data;
                }).finally(() => {
                    this.setFetching(false);
                });
            },
        }
    }
</script>
